// src/components/templates/NoNavLayout.js
import React from "react";
import { Box, Container } from "@mui/material";

const NoNavLayout = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Container
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 0, sm: 0 },
          py: { xs: 0, sm: 0 },
          mx: { xs: 0, sm: 0 },
          my: { xs: 0, sm: 0 },
          maxWidth: { xs: "100%", lg: "lg", xl: "xl" },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default NoNavLayout;
